// TODO v5: consider to make it private
export default function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/utils/setRef.js
// module id = 2844
// module chunks = 0